module.exports = __webpack_public_path__ + "static/media/CUSTOMLABELICON-01.22f55cf3.svg";